import { type FC, type PropsWithChildren, useState } from 'react';

import { TabsContext } from './context';

interface TabsProps extends PropsWithChildren {
  initActiveTab: string;
}

const Tabs: FC<TabsProps> = ({ children, initActiveTab }) => {
  const [activeTabId, setActiveTabId] = useState<string | null>(initActiveTab);

  return (
    <TabsContext.Provider value={{ activeTabId, setActiveTabId }}>
      {children}
    </TabsContext.Provider>
  );
};

export { Tabs, TabsContext };
